var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard-v3-container" }, [
    _c("header", { staticClass: "header-banner" }, [
      _c("div", { staticClass: "header-left" }, [
        _vm._m(0),
        _c("h1", { staticClass: "header-title" }, [
          _vm._v("Hệ Thống Quản Lý Giáo Dục Mầm Non"),
        ]),
        _c("p", { staticClass: "header-subtitle" }, [
          _c("i", { staticClass: "el-icon-date" }),
          _vm._v(" " + _vm._s(_vm.formattedCurrentDate) + "  | \n        "),
          _c("i", { staticClass: "el-icon-office-building" }),
          _vm._v(" " + _vm._s(_vm.currentSchoolName) + "\n      "),
        ]),
      ]),
    ]),
    _c("nav", { staticClass: "sticky-nav-wrapper" }, [
      _c(
        "div",
        { staticClass: "nav-cards-grid" },
        _vm._l(_vm.navSections, function (nav) {
          return _c(
            "button",
            {
              key: nav.id,
              class: ["nav-card-tab", { active: _vm.activeNav === nav.id }],
              style: {
                "--accent-color": nav.color,
                "--accent-bg": nav.bgColor,
              },
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.scrollToSection(nav.id)
                },
              },
            },
            [
              _c("div", { staticClass: "nav-card-icon" }, [
                _c("i", { class: nav.icon }),
              ]),
              _c("div", { staticClass: "nav-card-info" }, [
                _c("span", { staticClass: "nav-card-title" }, [
                  _vm._v(_vm._s(nav.name)),
                ]),
                _c("span", { staticClass: "nav-card-sub" }, [
                  _vm._v(_vm._s(nav.subtitle)),
                ]),
              ]),
              _c("div", { staticClass: "nav-card-glow-bar" }),
            ]
          )
        }),
        0
      ),
    ]),
    _c(
      "section",
      { staticClass: "dashboard-section", attrs: { id: "section-attendance" } },
      [
        _c("AttendanceStatisticsV3", {
          ref: "attendanceComp",
          attrs: { "auto-load": false },
        }),
      ],
      1
    ),
    _c(
      "section",
      {
        staticClass: "dashboard-section",
        attrs: { id: "section-emp-attendance" },
      },
      [
        _c("EmployeeAttendanceStatisticsV3", {
          ref: "empAttendanceComp",
          attrs: { "auto-load": false },
        }),
      ],
      1
    ),
    _c(
      "section",
      { staticClass: "dashboard-section", attrs: { id: "section-news" } },
      [
        _c("NewsStatisticsV3", {
          ref: "newsComp",
          attrs: { "auto-load": false },
        }),
      ],
      1
    ),
    _c(
      "section",
      { staticClass: "dashboard-section", attrs: { id: "section-evaluation" } },
      [
        _c("EvaluationStatisticsV3", {
          ref: "evaluationComp",
          attrs: { "auto-load": false },
        }),
      ],
      1
    ),
    _c(
      "section",
      { staticClass: "dashboard-section", attrs: { id: "section-schedule" } },
      [
        _c("ScheduleStatisticsV3", {
          ref: "scheduleComp",
          attrs: { "auto-load": false },
        }),
      ],
      1
    ),
    _c(
      "section",
      { staticClass: "dashboard-section", attrs: { id: "section-menu" } },
      [
        _c("MenuStatisticsV3", {
          ref: "menuComp",
          attrs: { "auto-load": false },
        }),
      ],
      1
    ),
    _c(
      "section",
      { staticClass: "dashboard-section", attrs: { id: "section-album" } },
      [
        _c("AlbumStatisticsV3", {
          ref: "albumComp",
          attrs: { "auto-load": false },
        }),
      ],
      1
    ),
    _c(
      "section",
      { staticClass: "dashboard-section", attrs: { id: "section-tuition" } },
      [
        _c("TuitionStatisticsV3", {
          ref: "tuitionComp",
          attrs: { "auto-load": false },
        }),
      ],
      1
    ),
    _c(
      "section",
      {
        staticClass: "dashboard-section",
        attrs: { id: "section-personnel-kpi" },
      },
      [
        _c("PersonnelKpiV3", {
          ref: "personnelKpiComp",
          attrs: { "auto-load": false },
        }),
      ],
      1
    ),
    _c(
      "section",
      { staticClass: "dashboard-section", attrs: { id: "section-birthday" } },
      [
        _c("BirthdayStatisticsV3", {
          ref: "birthdayComp",
          attrs: { "auto-load": false },
        }),
      ],
      1
    ),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "greeting-badge" }, [
      _c("span", { staticClass: "pulse-dot" }),
      _c("span", [_vm._v("BẢNG ĐIỀU KHIỂN THỐNG KÊ 3.0")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "dashboard-footer" }, [
      _c("p", [
        _vm._v(
          "Hệ Thống Báo Cáo & Quản Trị Toàn Diện OneKids • Phiên bản DashboardPlus V3.0"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }